
document.querySelectorAll(".tab_list .tab").forEach(tab => {
    tab.addEventListener("click", function () {
        // すべてのタブから active を削除
        document.querySelectorAll(".tab_list .tab").forEach(el => {
            el.classList.remove("active");
        });

        // クリックしたタブに active を追加
        this.classList.add("active");

        // IDを取得
        const id = this.id;

        // すべての .page_con から active を削除
        document.querySelectorAll(".page").forEach(el => {
            el.classList.remove("active");
        });

        // IDと同じクラス名を持つ要素に active を追加
        document.querySelectorAll("." + id).forEach(el => {
            el.classList.add("active");
        });
    });
});
